var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationTabletText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M18 18h44v-2H18zM18 64h44v-2H18z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 10c-2.206 0-4 1.794-4 4v52c0 2.206 1.794 4 4 4h34c2.206 0 4-1.794 4-4V14c0-2.206-1.794-4-4-4H23zm34 62H23c-3.309 0-6-2.691-6-6V14c0-3.309 2.691-6 6-6h34c3.309 0 6 2.691 6 6v52c0 3.309-2.691 6-6 6z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M34 14h12v-2H34zM38 68h4v-2h-4zM23 58h34V22H23v36zm35 2H22a1 1 0 01-1-1V21a1 1 0 011-1h36a1 1 0 011 1v38a1 1 0 01-1 1z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M27 28h2v-2h-2zM33 28h2v-2h-2zM39 28h2v-2h-2zM45 28h2v-2h-2zM51 28h2v-2h-2zM27 34h2v-2h-2zM33 34h2v-2h-2zM39 34h2v-2h-2zM45 34h2v-2h-2zM51 34h2v-2h-2zM27 40h2v-2h-2zM33 40h2v-2h-2zM39 40h2v-2h-2zM45 40h2v-2h-2zM51 40h2v-2h-2zM27 46h2v-2h-2zM33 46h2v-2h-2zM39 46h2v-2h-2zM27 54h2v-2h-2zM33 54h2v-2h-2zM39 54h2v-2h-2zM45 54h2v-2h-2zM51 54h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationTabletText;